import { api } from '@/api/client'

export interface TgFinding {
  severity: 'critical' | 'warning' | 'info'
  confidence: number
  category: string
  title: string
  detail: string
  affected_targets: string[]
  fix_text: string
  fix_cli: string
}

export interface TgDiagnosisResponse {
  tg_arn: string
  lb_type: string
  sg_check_available: boolean
  findings: TgFinding[]
  error?: string
}

export const targetGroupDiagnosticsApi = {
  diagnose: (tenantId: number, tgArn: string) =>
    api
      .get<TgDiagnosisResponse>(
        `/v1/tenants/${tenantId}/infrastructure/target-groups/diagnose?tg_arn=${encodeURIComponent(tgArn)}`,
      )
      .then((r) => r.data),
}
